// src/firebase-config.js
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth"; // Make sure to import getAuth
import { getDatabase } from "firebase/database";
const firebaseConfig = {
  apiKey: "AIzaSyCOzpBNwd5TEn-L-bQ0wjUxb0v0cLa-nPY",
  authDomain: "croptooex.firebaseapp.com",
  databaseURL: "https://croptooex-default-rtdb.firebaseio.com",
  projectId: "croptooex",
  storageBucket: "croptooex.appspot.com",
  messagingSenderId: "505322335922",
  appId: "1:505322335922:web:0b2832f8520304c8e4a3ab",
  measurementId: "G-2R31SS5N5X"
};
// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const analytics = getAnalytics(app);
const auth = getAuth(app); // Initialize auth

export { app,db, analytics, auth }; // Export auth here





